import { useVariant } from '@calendly/feature-check-react'
import moment from 'moment'

import { useGetUserQuery } from 'common'

import { useGetMeetingIntelligenceUserSettingsQuery } from '../../../../meeting_intelligence'

const MODAL_EXPERIMENT_KEY = 'growth_notetaker_free_trial_opt_out'
const GROWTH_EXPERIMENTS_OBJECT_KEY = 'nt_free_users_opt_out_experiment'
const MODAL_START_TIME = moment.utc('2025-12-10T13:00:00Z') // Dec 10 2025, 8 AM EST

export const useShouldShowNotetakerOptOutModal = () => {
  // Show modal only when:
  // - variant assignment for the experiment
  // - after the launch timestamp
  // - user has not opted out via growth experiments
  // - meeting intelligence / notetaker is not enabled

  const experimentGroupName = useVariant(MODAL_EXPERIMENT_KEY)
  const { data: userData, isSuccess: isUserSuccess } = useGetUserQuery()
  const {
    data: meetingIntelligenceUserData,
    isSuccess: isMeetingIntelligenceSuccess
  } = useGetMeetingIntelligenceUserSettingsQuery()

  const hasNotetakerEnabled = Boolean(meetingIntelligenceUserData?.miEnabled)
  const isAfterStart = moment().isSameOrAfter(MODAL_START_TIME)
  const optedOut = Boolean(
    userData?.growth_experiments?.[GROWTH_EXPERIMENTS_OBJECT_KEY]?.opted_out
  )
  const countryCode = userData?.country_code?.toUpperCase()

  if (!isUserSuccess || !isMeetingIntelligenceSuccess) {
    return false
  }

  return Boolean(
    isAfterStart
    && experimentGroupName === 'variant'
    && !optedOut
    && !hasNotetakerEnabled
    && countryCode === 'US'
  )
}
